import { Button } from 'antd';
import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

type Props = {
    type?: 'link' | 'text' | 'ghost' | 'default' | 'primary' | 'dashed' | undefined;
    title: string;
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
    light?: boolean;
    isAction?: boolean;
    style?: React.CSSProperties;
    className?: string;
    icon?: React.ReactElement;
    htmlType?: 'button' | 'reset' | 'submit';
    isArrow?: boolean;
    transparent?: boolean;
};
const HSButton: React.FC<Props> = ({
    type,
    title,
    className,
    light,
    style,
    loading,
    onClick,
    disabled,
    icon,
    isAction,
    htmlType,
    isArrow,
    transparent,
}) => {
    let classValue = type === 'link' ? '' : className || '';
    classValue =
        type === 'link'
            ? className || ''
            : light
            ? `common_btn_light ${classValue}`
            : transparent
            ? `common_btn_transparent`
            : isAction
            ? `common_action_btn ${classValue}`
            : `common_btn_primary ${classValue}`;
    return (
        <>
            <Button
                type={type}
                className={`${classValue} relative flex justify-center items-center ${
                    !disabled && !loading ? `hover:scale-110 ease-in-out duration-300 delay-150` : ''
                }`}
                loading={loading}
                style={style}
                onClick={onClick}
                disabled={disabled}
                icon={icon}
                htmlType={htmlType}
            >
                <span className="relative  title_btn">{title}</span>
                {isArrow && (
                    <span className="w-4 ml-1">
                        <FiArrowUpRight size={'1.8rem'} />
                    </span>
                )}
            </Button>
        </>
    );
};

export default HSButton;
